export { default } from './attribute-volume';